import { useLayoutEffect } from 'react';
import { useScrollStore } from '../store/scrollStore';

/** Restore the window scroll position saved under `key` on mount, and save it again on unmount. */
export function useScrollRestoration(key: string) {
  useLayoutEffect(() => {
    window.scrollTo(0, useScrollStore.getState().positions[key] ?? 0);
    return () => useScrollStore.getState().remember(key, window.scrollY);
  }, [key]);
}
